/**
 * HTML5 Notifications
 */
export default class KiteNotifications {

    constructor() {
        this.triggered = false;
        this.delayedNotification = null;
        this._1lvlDelay = 1500;
        this._2lvlDelay = 2500;
        this._1lvlTimeout = null;
        this._2lvlTimeout = null;
        this.focused = true;
        this.notification = false;
        this.notifications = [];
        this.notificationEnabled = null;
        this.defaultListeners = {
            click: () => {
                this.close();
                try {
                    window.focus();
                } catch (e) {
                    console.error(e);
                }
            }
        };
        this.createListeners();
    }

    /**
     *
     */
    init() {
        this.notification = window.Notification || false;

        if (!this.notification) {
            this.notificationEnabled = false;

            return;
        }

        const { permission } = this.notification;

        if (permission && permission === 'granted') {
            this.notificationEnabled = true;

            return;
        }

        if (!this.notificationEnabled) {
            document.documentElement.addEventListener('click', this.globalClickHandler);
        }

        if (!config.iAmRecorder) {
            this.notificationRequestPermission();
        }
    }

    /**
     *
     * @param title
     * @param opts
     * @param listeners
     */
    show() {
        this.delayedNotification = arguments;
        if (!this.triggered) {
            this.triggered = true;
            this._1lvlTimeout = setTimeout(() => {
                this.triggered = false;
                this._1lvlTimeout = null;
                this._show(...this.delayedNotification);
            }, this._1lvlDelay);
        } else if (!this._2lvlTimeout) {
            clearTimeout(this._1lvlTimeout);
            this._2lvlTimeout = setTimeout(() => {
                this.triggered = false;
                this._1lvlTimeout = null;
                this._2lvlTimeout = null;
                this._show(...this.delayedNotification);
            }, this._2lvlDelay);
        }
    }

    /**
     *
     * @param instance
     */
    close(instance) {
        for (let i = 0, n = this.notifications.length; i < n; i++) {
            const notification = this.notifications[i];

            if (instance && instance !== notification) {
                continue;
            }
            if (notification) {
                notification.cancel && notification.cancel();
                notification.close && notification.close();
            }
        }

        if (!instance) {
            this.notifications = [];
        } else {
            const idx = this.notifications.indexOf(instance);

            if (idx !== -1) {
                this.notifications.splice(idx, 1);
            }
        }
    }

    /**
     *
     */
    globalClickHandler = () => {
        this.init();
    };

    /**
     *
     */
    createListeners = () => {
        window.addEventListener('focus', this.handleFocus);
        window.addEventListener('blur', this.handleBlur);
        window.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('mousemove', this.handleMouseMove);
    };

    handleFocus = () => {
        this.focused = true;
        this.close();
    };

    handleBlur = () => {
        this.focused = false;
    };

    /**
     *
     */
    handleFocusOut = () => {
        this.focused = false;
    };

    /**
     *
     */
    handleMouseMove = () => {
        if (!this.focused) {
            this.focused = true;
        }
    };

    /**
     *
     */
    notificationRequestPermission = () => {
        this.notification.requestPermission(() => {
            const { permission, checkPermission } = this.notification;

            if ((permission && permission === 'granted') || (checkPermission && checkPermission === 0)) {
                this.notificationEnabled = true;
            } else {
                this.notificationEnabled = false;
            }
            document.documentElement.removeEventListener('click', this.globalClickHandler);
        });
    };

    /**
     *
     * @param o
     * @param l
     */
    applyListeners = (o, l) => {
        Object.keys(l).forEach(e => {
            l[e] = l[e] instanceof Array ? l[e] : [ l[e] ];
            l[e].forEach(listener => {
                o.addEventListener(e, function() {
                    typeof listener === 'function'
                        ? listener.apply(this, arguments)
                        : listener.handler && listener.handler.apply(listener.scope || this, arguments);
                });
            });
        });
    };


    /**
     *
     * @param title
     * @param opts
     * @param listeners
     * @returns {*}
     * @private
     */
    _show = (title, opts, listeners) => {
        if (!this.notificationEnabled || (opts && opts.hidden) || this.focused) {
            return;
        }

        const notification = new Notification(title, opts);

        this.applyListeners(notification, this.defaultListeners);
        this.applyListeners(notification, listeners || {});

        notification.show && notification.show();

        this.close();
        this.notifications.push(notification);

        return notification;
    };

}
